import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Grid, Card } from "@mui/material";
import { theme, StyledMultilineTextField } from "../StyledComponents";
import { FIELD_SET_IDS } from "../config/defaults/fieldLayoutUtils";
import useSectionFieldLayout from "../config/hooks/useSectionFieldLayout";

const Notes = ({
  sectionName,
  activeSection,
  data = {},
  setData,
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = useSectionFieldLayout(
    fieldLayoutProp,
    FIELD_SET_IDS.notes,
  );

  const handleInputChange = (field, value) => {
    let updatedDetails = { ...data, [field]: value };

    setData(updatedDetails);
  };

  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid container spacing={2} sx={{ padding: "10px" }}>
            {fieldLayout.isFieldVisible("note") && (
              <Grid item {...fieldLayout.getFieldGrid("note", { xs: 12, sm: 12, md: 12 })}>
                <StyledMultilineTextField
                  id="outlined-multiline-static-notes"
                  label={fieldLayout.getFieldLabel("note", "Notes")}
                  multiline
                  rows={2}
                  value={data.note || ""}
                  onChange={(e) => handleInputChange("note", e.target.value)}
                  fullWidth
                  error={!data.note?.trim() && fieldLayout.isFieldRequired("note")}
                  helperText={
                    !data.note?.trim() && fieldLayout.isFieldRequired("note")
                      ? "Notes is a mandatory field."
                      : ""
                  }
                />
              </Grid>
            )}
          </Grid>
        </Card>
      ) : null}
    </ThemeProvider>
  );
};

export default Notes;
